module.exports = __webpack_public_path__ + "img/adv_icon8.c0341615.png";